module.exports = __webpack_public_path__ + "static/assets/6a23ae0c67e318bd7c7881be4bb0550d.png";